// extracted by mini-css-extract-plugin
module.exports = {"vitals":"Service-module--vitals--3ocPC","topContainer":"Service-module--topContainer--RI03o"};